module.exports = __webpack_public_path__ + "static/media/rectangle@3x.dfa5b32f.png";